import {
  ProvinceListView,
  ProvinceNewView,
  ProvinceEditView,
} from '@/views/authenticated/provinces';

export default [
  {
    path: '/provinces',
    name: 'app_province_list',
    meta: { title: 'Provinces', redirectAuthenticatedUsers: false, requiresAdmin: true },
    component: ProvinceListView,
  },
  {
    path: '/provinces/new',
    name: 'app_province_new',
    meta: { title: 'Add a Province', redirectAuthenticatedUsers: false, requiresAdmin: true },
    component: ProvinceNewView,
  },
  {
    path: '/provinces/:province/edit',
    name: 'app_province_edit',
    meta: { title: 'Edit a Province', redirectAuthenticatedUsers: false, requiresAdmin: true },
    component: ProvinceEditView,
  },
];
